import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import { Application } from '../../../../common/models/application.interface';
import { ApiResponse } from '../../../../common/models/api-response.interface';
import { ApplicationService } from '../../shared/services/application.service';
import {
    GetApplicationListRequest,
    GetApplicationListRequestSuccess
} from './utils.action';
import { AddAPIErrorAlert } from '../../alerts/store/alerts.action';
import { Observable, of } from 'rxjs';

@Injectable()
export class UtilsEffects {
    listAllApplications$ = createEffect(() =>
        this.actions$.pipe(
            filter(
                (action: Action) => action instanceof GetApplicationListRequest
            ),
            mergeMap(() =>
                this.applicationService.list().pipe(
                    map(
                        (response: ApiResponse<Application[]>) =>
                            new GetApplicationListRequestSuccess(response.data)
                    ),
                    catchError((err) => of(new AddAPIErrorAlert(err.error)))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private applicationService: ApplicationService
    ) {}
}
